import { select, call, put } from "redux-saga/effects";

import { sendSchoolMoneyDataRequest } from "state/fetchSagas";
import { getParentalConsentItemByID } from "state/school_money/selectors";
import {
  fetchActivePayments,
  updateParentalConsentSucceeded,
  updateParentalConsentFailed
} from "state/school_money/actions";

export default function* updateParentalConsentSaga(action) {
  
  const { itemID, status } = action.payload;
  const { serverID, remoteSchoolID, remoteParentID, remoteInstallmentID } = yield select(getParentalConsentItemByID, itemID);
  
  try {
    
    yield call(sendSchoolMoneyDataRequest, "update_parental_consent", {
      server_id: serverID,
      remote_school_id: remoteSchoolID,
      remote_parent_id: remoteParentID,
      installment_id: remoteInstallmentID,
      consent: status
    });
    
    yield put(updateParentalConsentSucceeded(itemID, status));
    yield put(fetchActivePayments());
    
  } catch (error) {
    yield put(updateParentalConsentFailed(itemID, error));
  }
  
}



// WEBPACK FOOTER //
// ./src/state/school_money/sagas/updateParentalConsentSaga.js